<template>
    <div>
        <strong>{{ $_.get(activity, "actorUser.name") }}</strong> kullanıcısı:
        <span v-for="(assignee, index) in $_.get(activity, 'payload.assignees')" :key="index">
            <strong>{{ assignee }} </strong>,
        </span>
        <strong>"{{ $_.get(activity, "payload.taskTitle") }}"</strong> adlı göreve atadı.
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "TaskAssignedToUser",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
});
</script>

<style scoped lang="scss"></style>
